
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/help/article/[urlName]",
      function () {
        return require("private-next-pages/help/article/[urlName].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/help/article/[urlName]"])
      });
    }
  